// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".icon-item[data-v-3eceaad0]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.icon-item[data-v-3eceaad0]:hover{color:#1976d3;background:#f5f7fa}.icon-selector[data-v-3eceaad0]{display:inline-block;border:1px dashed #dcdfe6;border-radius:5px}", ""]);
// Exports
module.exports = exports;
